/**
 * @fileoverview gRPC-Web generated client stub for manabie.bob
 * @enhanceable
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var grpc = {};
grpc.web = require('grpc-web');

var enum_pb = require('./enum_pb.js');

var courses_pb = require('./courses_pb.js');

var schools_pb = require('./schools_pb.js');

var user_pb = require('./user_pb.js');

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');

var proto = {};
proto.manabie = {};
proto.manabie.bob = require('./student_pb.js');
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */

proto.manabie.bob.StudentClient = function (hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';
  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  /**
   * @private @const {string} The hostname
   */

  this.hostname_ = hostname;
  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */

  this.credentials_ = credentials;
  /**
   * @private @const {?Object} Options for the client
   */

  this.options_ = options;
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */


proto.manabie.bob.StudentPromiseClient = function (hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';
  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  /**
   * @private @const {string} The hostname
   */

  this.hostname_ = hostname;
  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */

  this.credentials_ = credentials;
  /**
   * @private @const {?Object} Options for the client
   */

  this.options_ = options;
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RegisterRequest,
 *   !proto.manabie.bob.RegisterResponse>}
 */


var methodDescriptor_Student_Register = new grpc.web.MethodDescriptor('/manabie.bob.Student/Register', grpc.web.MethodType.UNARY, proto.manabie.bob.RegisterRequest, proto.manabie.bob.RegisterResponse,
/** @param {!proto.manabie.bob.RegisterRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RegisterResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RegisterRequest,
 *   !proto.manabie.bob.RegisterResponse>}
 */

var methodInfo_Student_Register = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RegisterResponse,
/** @param {!proto.manabie.bob.RegisterRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RegisterResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RegisterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RegisterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RegisterResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.register = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/Register', request, metadata || {}, methodDescriptor_Student_Register, callback);
};
/**
 * @param {!proto.manabie.bob.RegisterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RegisterResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.register = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/Register', request, metadata || {}, methodDescriptor_Student_Register);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.GetStudentProfileRequest,
 *   !proto.manabie.bob.GetStudentProfileResponse>}
 */


var methodDescriptor_Student_GetStudentProfile = new grpc.web.MethodDescriptor('/manabie.bob.Student/GetStudentProfile', grpc.web.MethodType.UNARY, proto.manabie.bob.GetStudentProfileRequest, proto.manabie.bob.GetStudentProfileResponse,
/** @param {!proto.manabie.bob.GetStudentProfileRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.GetStudentProfileResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.GetStudentProfileRequest,
 *   !proto.manabie.bob.GetStudentProfileResponse>}
 */

var methodInfo_Student_GetStudentProfile = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.GetStudentProfileResponse,
/** @param {!proto.manabie.bob.GetStudentProfileRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.GetStudentProfileResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.GetStudentProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.GetStudentProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.GetStudentProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.getStudentProfile = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/GetStudentProfile', request, metadata || {}, methodDescriptor_Student_GetStudentProfile, callback);
};
/**
 * @param {!proto.manabie.bob.GetStudentProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.GetStudentProfileResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.getStudentProfile = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/GetStudentProfile', request, metadata || {}, methodDescriptor_Student_GetStudentProfile);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.UpdateProfileRequest,
 *   !proto.manabie.bob.UpdateProfileResponse>}
 */


var methodDescriptor_Student_UpdateProfile = new grpc.web.MethodDescriptor('/manabie.bob.Student/UpdateProfile', grpc.web.MethodType.UNARY, proto.manabie.bob.UpdateProfileRequest, proto.manabie.bob.UpdateProfileResponse,
/** @param {!proto.manabie.bob.UpdateProfileRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdateProfileResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.UpdateProfileRequest,
 *   !proto.manabie.bob.UpdateProfileResponse>}
 */

var methodInfo_Student_UpdateProfile = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.UpdateProfileResponse,
/** @param {!proto.manabie.bob.UpdateProfileRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdateProfileResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.UpdateProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.UpdateProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.UpdateProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.updateProfile = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/UpdateProfile', request, metadata || {}, methodDescriptor_Student_UpdateProfile, callback);
};
/**
 * @param {!proto.manabie.bob.UpdateProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.UpdateProfileResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.updateProfile = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/UpdateProfile', request, metadata || {}, methodDescriptor_Student_UpdateProfile);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveStudentStatRequest,
 *   !proto.manabie.bob.RetrieveStudentStatResponse>}
 */


var methodDescriptor_Student_RetrieveStat = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveStat', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveStudentStatRequest, proto.manabie.bob.RetrieveStudentStatResponse,
/** @param {!proto.manabie.bob.RetrieveStudentStatRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentStatResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveStudentStatRequest,
 *   !proto.manabie.bob.RetrieveStudentStatResponse>}
 */

var methodInfo_Student_RetrieveStat = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveStudentStatResponse,
/** @param {!proto.manabie.bob.RetrieveStudentStatRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentStatResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveStudentStatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveStudentStatResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveStudentStatResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveStat = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveStat', request, metadata || {}, methodDescriptor_Student_RetrieveStat, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveStudentStatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveStudentStatResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveStat = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveStat', request, metadata || {}, methodDescriptor_Student_RetrieveStat);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RenewStudentBillingDateRequest,
 *   !proto.manabie.bob.RenewStudentBillingDateResponse>}
 */


var methodDescriptor_Student_RenewStudentBillingDate = new grpc.web.MethodDescriptor('/manabie.bob.Student/RenewStudentBillingDate', grpc.web.MethodType.UNARY, proto.manabie.bob.RenewStudentBillingDateRequest, proto.manabie.bob.RenewStudentBillingDateResponse,
/** @param {!proto.manabie.bob.RenewStudentBillingDateRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RenewStudentBillingDateResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RenewStudentBillingDateRequest,
 *   !proto.manabie.bob.RenewStudentBillingDateResponse>}
 */

var methodInfo_Student_RenewStudentBillingDate = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RenewStudentBillingDateResponse,
/** @param {!proto.manabie.bob.RenewStudentBillingDateRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RenewStudentBillingDateResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RenewStudentBillingDateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RenewStudentBillingDateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RenewStudentBillingDateResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.renewStudentBillingDate = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RenewStudentBillingDate', request, metadata || {}, methodDescriptor_Student_RenewStudentBillingDate, callback);
};
/**
 * @param {!proto.manabie.bob.RenewStudentBillingDateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RenewStudentBillingDateResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.renewStudentBillingDate = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RenewStudentBillingDate', request, metadata || {}, methodDescriptor_Student_RenewStudentBillingDate);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.FindStudentRequest,
 *   !proto.manabie.bob.FindStudentResponse>}
 */


var methodDescriptor_Student_FindStudent = new grpc.web.MethodDescriptor('/manabie.bob.Student/FindStudent', grpc.web.MethodType.UNARY, proto.manabie.bob.FindStudentRequest, proto.manabie.bob.FindStudentResponse,
/** @param {!proto.manabie.bob.FindStudentRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.FindStudentResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.FindStudentRequest,
 *   !proto.manabie.bob.FindStudentResponse>}
 */

var methodInfo_Student_FindStudent = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.FindStudentResponse,
/** @param {!proto.manabie.bob.FindStudentRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.FindStudentResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.FindStudentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.FindStudentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.FindStudentResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.findStudent = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/FindStudent', request, metadata || {}, methodDescriptor_Student_FindStudent, callback);
};
/**
 * @param {!proto.manabie.bob.FindStudentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.FindStudentResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.findStudent = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/FindStudent', request, metadata || {}, methodDescriptor_Student_FindStudent);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveDailyLOFinishedRequest,
 *   !proto.manabie.bob.RetrieveDailyLOFinishedResponse>}
 */


var methodDescriptor_Student_RetrieveDailyLOFinished = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveDailyLOFinished', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveDailyLOFinishedRequest, proto.manabie.bob.RetrieveDailyLOFinishedResponse,
/** @param {!proto.manabie.bob.RetrieveDailyLOFinishedRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveDailyLOFinishedResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveDailyLOFinishedRequest,
 *   !proto.manabie.bob.RetrieveDailyLOFinishedResponse>}
 */

var methodInfo_Student_RetrieveDailyLOFinished = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveDailyLOFinishedResponse,
/** @param {!proto.manabie.bob.RetrieveDailyLOFinishedRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveDailyLOFinishedResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveDailyLOFinishedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveDailyLOFinishedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveDailyLOFinishedResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveDailyLOFinished = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveDailyLOFinished', request, metadata || {}, methodDescriptor_Student_RetrieveDailyLOFinished, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveDailyLOFinishedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveDailyLOFinishedResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveDailyLOFinished = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveDailyLOFinished', request, metadata || {}, methodDescriptor_Student_RetrieveDailyLOFinished);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveStudyAheadTopicsRequest,
 *   !proto.manabie.bob.RetrieveStudyAheadTopicsResponse>}
 */


var methodDescriptor_Student_RetrieveStudyAheadTopics = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveStudyAheadTopics', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveStudyAheadTopicsRequest, proto.manabie.bob.RetrieveStudyAheadTopicsResponse,
/** @param {!proto.manabie.bob.RetrieveStudyAheadTopicsRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudyAheadTopicsResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveStudyAheadTopicsRequest,
 *   !proto.manabie.bob.RetrieveStudyAheadTopicsResponse>}
 */

var methodInfo_Student_RetrieveStudyAheadTopics = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveStudyAheadTopicsResponse,
/** @param {!proto.manabie.bob.RetrieveStudyAheadTopicsRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudyAheadTopicsResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveStudyAheadTopicsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveStudyAheadTopicsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveStudyAheadTopicsResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveStudyAheadTopics = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudyAheadTopics', request, metadata || {}, methodDescriptor_Student_RetrieveStudyAheadTopics, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveStudyAheadTopicsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveStudyAheadTopicsResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveStudyAheadTopics = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudyAheadTopics', request, metadata || {}, methodDescriptor_Student_RetrieveStudyAheadTopics);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveTotalLOsFinishedRequest,
 *   !proto.manabie.bob.RetrieveTotalLOsFinishedResponse>}
 */


var methodDescriptor_Student_RetrieveTotalLOsFinished = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveTotalLOsFinished', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveTotalLOsFinishedRequest, proto.manabie.bob.RetrieveTotalLOsFinishedResponse,
/** @param {!proto.manabie.bob.RetrieveTotalLOsFinishedRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveTotalLOsFinishedResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveTotalLOsFinishedRequest,
 *   !proto.manabie.bob.RetrieveTotalLOsFinishedResponse>}
 */

var methodInfo_Student_RetrieveTotalLOsFinished = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveTotalLOsFinishedResponse,
/** @param {!proto.manabie.bob.RetrieveTotalLOsFinishedRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveTotalLOsFinishedResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveTotalLOsFinishedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveTotalLOsFinishedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveTotalLOsFinishedResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveTotalLOsFinished = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveTotalLOsFinished', request, metadata || {}, methodDescriptor_Student_RetrieveTotalLOsFinished, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveTotalLOsFinishedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveTotalLOsFinishedResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveTotalLOsFinished = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveTotalLOsFinished', request, metadata || {}, methodDescriptor_Student_RetrieveTotalLOsFinished);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveArchivedTopicsRequest,
 *   !proto.manabie.bob.RetrieveArchivedTopicsResponse>}
 */


var methodDescriptor_Student_RetrieveArchivedTopics = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveArchivedTopics', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveArchivedTopicsRequest, proto.manabie.bob.RetrieveArchivedTopicsResponse,
/** @param {!proto.manabie.bob.RetrieveArchivedTopicsRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveArchivedTopicsResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveArchivedTopicsRequest,
 *   !proto.manabie.bob.RetrieveArchivedTopicsResponse>}
 */

var methodInfo_Student_RetrieveArchivedTopics = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveArchivedTopicsResponse,
/** @param {!proto.manabie.bob.RetrieveArchivedTopicsRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveArchivedTopicsResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveArchivedTopicsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveArchivedTopicsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveArchivedTopicsResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveArchivedTopics = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveArchivedTopics', request, metadata || {}, methodDescriptor_Student_RetrieveArchivedTopics, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveArchivedTopicsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveArchivedTopicsResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveArchivedTopics = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveArchivedTopics', request, metadata || {}, methodDescriptor_Student_RetrieveArchivedTopics);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.CountTotalLOsFinishedRequest,
 *   !proto.manabie.bob.CountTotalLOsFinishedResponse>}
 */


var methodDescriptor_Student_CountTotalLOsFinished = new grpc.web.MethodDescriptor('/manabie.bob.Student/CountTotalLOsFinished', grpc.web.MethodType.UNARY, proto.manabie.bob.CountTotalLOsFinishedRequest, proto.manabie.bob.CountTotalLOsFinishedResponse,
/** @param {!proto.manabie.bob.CountTotalLOsFinishedRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CountTotalLOsFinishedResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.CountTotalLOsFinishedRequest,
 *   !proto.manabie.bob.CountTotalLOsFinishedResponse>}
 */

var methodInfo_Student_CountTotalLOsFinished = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.CountTotalLOsFinishedResponse,
/** @param {!proto.manabie.bob.CountTotalLOsFinishedRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CountTotalLOsFinishedResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.CountTotalLOsFinishedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.CountTotalLOsFinishedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.CountTotalLOsFinishedResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.countTotalLOsFinished = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/CountTotalLOsFinished', request, metadata || {}, methodDescriptor_Student_CountTotalLOsFinished, callback);
};
/**
 * @param {!proto.manabie.bob.CountTotalLOsFinishedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.CountTotalLOsFinishedResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.countTotalLOsFinished = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/CountTotalLOsFinished', request, metadata || {}, methodDescriptor_Student_CountTotalLOsFinished);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.StudentEventLogRequest,
 *   !proto.manabie.bob.StudentEventLogResponse>}
 */


var methodDescriptor_Student_CreateStudentEventLogs = new grpc.web.MethodDescriptor('/manabie.bob.Student/CreateStudentEventLogs', grpc.web.MethodType.UNARY, proto.manabie.bob.StudentEventLogRequest, proto.manabie.bob.StudentEventLogResponse,
/** @param {!proto.manabie.bob.StudentEventLogRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.StudentEventLogResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.StudentEventLogRequest,
 *   !proto.manabie.bob.StudentEventLogResponse>}
 */

var methodInfo_Student_CreateStudentEventLogs = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.StudentEventLogResponse,
/** @param {!proto.manabie.bob.StudentEventLogRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.StudentEventLogResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.StudentEventLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.StudentEventLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.StudentEventLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.createStudentEventLogs = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/CreateStudentEventLogs', request, metadata || {}, methodDescriptor_Student_CreateStudentEventLogs, callback);
};
/**
 * @param {!proto.manabie.bob.StudentEventLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.StudentEventLogResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.createStudentEventLogs = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/CreateStudentEventLogs', request, metadata || {}, methodDescriptor_Student_CreateStudentEventLogs);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveLearningProgressRequest,
 *   !proto.manabie.bob.RetrieveLearningProgressResponse>}
 */


var methodDescriptor_Student_RetrieveLearningProgress = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveLearningProgress', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveLearningProgressRequest, proto.manabie.bob.RetrieveLearningProgressResponse,
/** @param {!proto.manabie.bob.RetrieveLearningProgressRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveLearningProgressResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveLearningProgressRequest,
 *   !proto.manabie.bob.RetrieveLearningProgressResponse>}
 */

var methodInfo_Student_RetrieveLearningProgress = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveLearningProgressResponse,
/** @param {!proto.manabie.bob.RetrieveLearningProgressRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveLearningProgressResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveLearningProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveLearningProgressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveLearningProgressResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveLearningProgress = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveLearningProgress', request, metadata || {}, methodDescriptor_Student_RetrieveLearningProgress, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveLearningProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveLearningProgressResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveLearningProgress = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveLearningProgress', request, metadata || {}, methodDescriptor_Student_RetrieveLearningProgress);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.AssignToCoachRequest,
 *   !proto.manabie.bob.AssignToCoachResponse>}
 */


var methodDescriptor_Student_AssignToCoach = new grpc.web.MethodDescriptor('/manabie.bob.Student/AssignToCoach', grpc.web.MethodType.UNARY, proto.manabie.bob.AssignToCoachRequest, proto.manabie.bob.AssignToCoachResponse,
/** @param {!proto.manabie.bob.AssignToCoachRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.AssignToCoachResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.AssignToCoachRequest,
 *   !proto.manabie.bob.AssignToCoachResponse>}
 */

var methodInfo_Student_AssignToCoach = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.AssignToCoachResponse,
/** @param {!proto.manabie.bob.AssignToCoachRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.AssignToCoachResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.AssignToCoachRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.AssignToCoachResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.AssignToCoachResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.assignToCoach = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/AssignToCoach', request, metadata || {}, methodDescriptor_Student_AssignToCoach, callback);
};
/**
 * @param {!proto.manabie.bob.AssignToCoachRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.AssignToCoachResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.assignToCoach = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/AssignToCoach', request, metadata || {}, methodDescriptor_Student_AssignToCoach);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrievePresetStudyPlansRequest,
 *   !proto.manabie.bob.RetrievePresetStudyPlansResponse>}
 */


var methodDescriptor_Student_RetrievePresetStudyPlans = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrievePresetStudyPlans', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrievePresetStudyPlansRequest, proto.manabie.bob.RetrievePresetStudyPlansResponse,
/** @param {!proto.manabie.bob.RetrievePresetStudyPlansRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePresetStudyPlansResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrievePresetStudyPlansRequest,
 *   !proto.manabie.bob.RetrievePresetStudyPlansResponse>}
 */

var methodInfo_Student_RetrievePresetStudyPlans = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrievePresetStudyPlansResponse,
/** @param {!proto.manabie.bob.RetrievePresetStudyPlansRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePresetStudyPlansResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrievePresetStudyPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrievePresetStudyPlansResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrievePresetStudyPlansResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrievePresetStudyPlans = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrievePresetStudyPlans', request, metadata || {}, methodDescriptor_Student_RetrievePresetStudyPlans, callback);
};
/**
 * @param {!proto.manabie.bob.RetrievePresetStudyPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrievePresetStudyPlansResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrievePresetStudyPlans = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrievePresetStudyPlans', request, metadata || {}, methodDescriptor_Student_RetrievePresetStudyPlans);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest,
 *   !proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse>}
 */


var methodDescriptor_Student_RetrievePresetStudyPlanWeeklies = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrievePresetStudyPlanWeeklies', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest, proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse,
/** @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest,
 *   !proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse>}
 */

var methodInfo_Student_RetrievePresetStudyPlanWeeklies = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse,
/** @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrievePresetStudyPlanWeeklies = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrievePresetStudyPlanWeeklies', request, metadata || {}, methodDescriptor_Student_RetrievePresetStudyPlanWeeklies, callback);
};
/**
 * @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrievePresetStudyPlanWeeklies = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrievePresetStudyPlanWeeklies', request, metadata || {}, methodDescriptor_Student_RetrievePresetStudyPlanWeeklies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.AssignPresetStudyPlansRequest,
 *   !proto.manabie.bob.AssignPresetStudyPlansResponse>}
 */


var methodDescriptor_Student_AssignPresetStudyPlans = new grpc.web.MethodDescriptor('/manabie.bob.Student/AssignPresetStudyPlans', grpc.web.MethodType.UNARY, proto.manabie.bob.AssignPresetStudyPlansRequest, proto.manabie.bob.AssignPresetStudyPlansResponse,
/** @param {!proto.manabie.bob.AssignPresetStudyPlansRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.AssignPresetStudyPlansResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.AssignPresetStudyPlansRequest,
 *   !proto.manabie.bob.AssignPresetStudyPlansResponse>}
 */

var methodInfo_Student_AssignPresetStudyPlans = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.AssignPresetStudyPlansResponse,
/** @param {!proto.manabie.bob.AssignPresetStudyPlansRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.AssignPresetStudyPlansResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.AssignPresetStudyPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.AssignPresetStudyPlansResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.AssignPresetStudyPlansResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.assignPresetStudyPlans = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/AssignPresetStudyPlans', request, metadata || {}, methodDescriptor_Student_AssignPresetStudyPlans, callback);
};
/**
 * @param {!proto.manabie.bob.AssignPresetStudyPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.AssignPresetStudyPlansResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.assignPresetStudyPlans = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/AssignPresetStudyPlans', request, metadata || {}, methodDescriptor_Student_AssignPresetStudyPlans);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveStudentStudyPlansRequest,
 *   !proto.manabie.bob.RetrieveStudentStudyPlansResponse>}
 */


var methodDescriptor_Student_RetrieveStudentStudyPlans = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveStudentStudyPlans', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveStudentStudyPlansRequest, proto.manabie.bob.RetrieveStudentStudyPlansResponse,
/** @param {!proto.manabie.bob.RetrieveStudentStudyPlansRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentStudyPlansResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveStudentStudyPlansRequest,
 *   !proto.manabie.bob.RetrieveStudentStudyPlansResponse>}
 */

var methodInfo_Student_RetrieveStudentStudyPlans = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveStudentStudyPlansResponse,
/** @param {!proto.manabie.bob.RetrieveStudentStudyPlansRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentStudyPlansResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveStudentStudyPlansResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveStudentStudyPlansResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveStudentStudyPlans = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudentStudyPlans', request, metadata || {}, methodDescriptor_Student_RetrieveStudentStudyPlans, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveStudentStudyPlansResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveStudentStudyPlans = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudentStudyPlans', request, metadata || {}, methodDescriptor_Student_RetrieveStudentStudyPlans);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest,
 *   !proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse>}
 */


var methodDescriptor_Student_RetrieveStudentStudyPlanWeeklies = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveStudentStudyPlanWeeklies', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest, proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse,
/** @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest,
 *   !proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse>}
 */

var methodInfo_Student_RetrieveStudentStudyPlanWeeklies = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse,
/** @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveStudentStudyPlanWeeklies = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudentStudyPlanWeeklies', request, metadata || {}, methodDescriptor_Student_RetrieveStudentStudyPlanWeeklies, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveStudentStudyPlanWeeklies = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudentStudyPlanWeeklies', request, metadata || {}, methodDescriptor_Student_RetrieveStudentStudyPlanWeeklies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.UpsertStudentCommentRequest,
 *   !proto.manabie.bob.UpsertStudentCommentResponse>}
 */


var methodDescriptor_Student_UpsertStudentComment = new grpc.web.MethodDescriptor('/manabie.bob.Student/UpsertStudentComment', grpc.web.MethodType.UNARY, proto.manabie.bob.UpsertStudentCommentRequest, proto.manabie.bob.UpsertStudentCommentResponse,
/** @param {!proto.manabie.bob.UpsertStudentCommentRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpsertStudentCommentResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.UpsertStudentCommentRequest,
 *   !proto.manabie.bob.UpsertStudentCommentResponse>}
 */

var methodInfo_Student_UpsertStudentComment = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.UpsertStudentCommentResponse,
/** @param {!proto.manabie.bob.UpsertStudentCommentRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpsertStudentCommentResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.UpsertStudentCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.UpsertStudentCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.UpsertStudentCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.upsertStudentComment = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/UpsertStudentComment', request, metadata || {}, methodDescriptor_Student_UpsertStudentComment, callback);
};
/**
 * @param {!proto.manabie.bob.UpsertStudentCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.UpsertStudentCommentResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.upsertStudentComment = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/UpsertStudentComment', request, metadata || {}, methodDescriptor_Student_UpsertStudentComment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveStudentCommentRequest,
 *   !proto.manabie.bob.RetrieveStudentCommentResponse>}
 */


var methodDescriptor_Student_RetrieveStudentComment = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveStudentComment', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveStudentCommentRequest, proto.manabie.bob.RetrieveStudentCommentResponse,
/** @param {!proto.manabie.bob.RetrieveStudentCommentRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentCommentResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveStudentCommentRequest,
 *   !proto.manabie.bob.RetrieveStudentCommentResponse>}
 */

var methodInfo_Student_RetrieveStudentComment = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveStudentCommentResponse,
/** @param {!proto.manabie.bob.RetrieveStudentCommentRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentCommentResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveStudentCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveStudentCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveStudentCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveStudentComment = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudentComment', request, metadata || {}, methodDescriptor_Student_RetrieveStudentComment, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveStudentCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveStudentCommentResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveStudentComment = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudentComment', request, metadata || {}, methodDescriptor_Student_RetrieveStudentComment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveStudentBillingHistoryRequest,
 *   !proto.manabie.bob.RetrieveStudentBillingHistoryResponse>}
 */


var methodDescriptor_Student_RetrieveStudentBillingHistory = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveStudentBillingHistory', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveStudentBillingHistoryRequest, proto.manabie.bob.RetrieveStudentBillingHistoryResponse,
/** @param {!proto.manabie.bob.RetrieveStudentBillingHistoryRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentBillingHistoryResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveStudentBillingHistoryRequest,
 *   !proto.manabie.bob.RetrieveStudentBillingHistoryResponse>}
 */

var methodInfo_Student_RetrieveStudentBillingHistory = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveStudentBillingHistoryResponse,
/** @param {!proto.manabie.bob.RetrieveStudentBillingHistoryRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveStudentBillingHistoryResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveStudentBillingHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveStudentBillingHistoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveStudentBillingHistoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveStudentBillingHistory = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudentBillingHistory', request, metadata || {}, methodDescriptor_Student_RetrieveStudentBillingHistory, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveStudentBillingHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveStudentBillingHistoryResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveStudentBillingHistory = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveStudentBillingHistory', request, metadata || {}, methodDescriptor_Student_RetrieveStudentBillingHistory);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.StudentPermissionRequest,
 *   !proto.manabie.bob.StudentPermissionResponse>}
 */


var methodDescriptor_Student_StudentPermission = new grpc.web.MethodDescriptor('/manabie.bob.Student/StudentPermission', grpc.web.MethodType.UNARY, proto.manabie.bob.StudentPermissionRequest, proto.manabie.bob.StudentPermissionResponse,
/** @param {!proto.manabie.bob.StudentPermissionRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.StudentPermissionResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.StudentPermissionRequest,
 *   !proto.manabie.bob.StudentPermissionResponse>}
 */

var methodInfo_Student_StudentPermission = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.StudentPermissionResponse,
/** @param {!proto.manabie.bob.StudentPermissionRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.StudentPermissionResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.StudentPermissionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.StudentPermissionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.StudentPermissionResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.studentPermission = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/StudentPermission', request, metadata || {}, methodDescriptor_Student_StudentPermission, callback);
};
/**
 * @param {!proto.manabie.bob.StudentPermissionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.StudentPermissionResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.studentPermission = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/StudentPermission', request, metadata || {}, methodDescriptor_Student_StudentPermission);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.ApplyActivationCodeRequest,
 *   !proto.manabie.bob.ApplyActivationCodeResponse>}
 */


var methodDescriptor_Student_ApplyActivationCode = new grpc.web.MethodDescriptor('/manabie.bob.Student/ApplyActivationCode', grpc.web.MethodType.UNARY, proto.manabie.bob.ApplyActivationCodeRequest, proto.manabie.bob.ApplyActivationCodeResponse,
/** @param {!proto.manabie.bob.ApplyActivationCodeRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.ApplyActivationCodeResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.ApplyActivationCodeRequest,
 *   !proto.manabie.bob.ApplyActivationCodeResponse>}
 */

var methodInfo_Student_ApplyActivationCode = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.ApplyActivationCodeResponse,
/** @param {!proto.manabie.bob.ApplyActivationCodeRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.ApplyActivationCodeResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.ApplyActivationCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.ApplyActivationCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.ApplyActivationCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.applyActivationCode = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/ApplyActivationCode', request, metadata || {}, methodDescriptor_Student_ApplyActivationCode, callback);
};
/**
 * @param {!proto.manabie.bob.ApplyActivationCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.ApplyActivationCodeResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.applyActivationCode = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/ApplyActivationCode', request, metadata || {}, methodDescriptor_Student_ApplyActivationCode);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveOverdueTopicRequest,
 *   !proto.manabie.bob.RetrieveOverdueTopicResponse>}
 */


var methodDescriptor_Student_RetrieveOverdueTopic = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveOverdueTopic', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveOverdueTopicRequest, proto.manabie.bob.RetrieveOverdueTopicResponse,
/** @param {!proto.manabie.bob.RetrieveOverdueTopicRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveOverdueTopicResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveOverdueTopicRequest,
 *   !proto.manabie.bob.RetrieveOverdueTopicResponse>}
 */

var methodInfo_Student_RetrieveOverdueTopic = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveOverdueTopicResponse,
/** @param {!proto.manabie.bob.RetrieveOverdueTopicRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveOverdueTopicResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveOverdueTopicRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveOverdueTopicResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveOverdueTopicResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveOverdueTopic = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveOverdueTopic', request, metadata || {}, methodDescriptor_Student_RetrieveOverdueTopic, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveOverdueTopicRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveOverdueTopicResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveOverdueTopic = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveOverdueTopic', request, metadata || {}, methodDescriptor_Student_RetrieveOverdueTopic);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest,
 *   !proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse>}
 */


var methodDescriptor_Student_RetrieveCompletedTopicWeeklies = new grpc.web.MethodDescriptor('/manabie.bob.Student/RetrieveCompletedTopicWeeklies', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest, proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse,
/** @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest,
 *   !proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse>}
 */

var methodInfo_Student_RetrieveCompletedTopicWeeklies = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse,
/** @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.StudentClient.prototype.retrieveCompletedTopicWeeklies = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.Student/RetrieveCompletedTopicWeeklies', request, metadata || {}, methodDescriptor_Student_RetrieveCompletedTopicWeeklies, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.StudentPromiseClient.prototype.retrieveCompletedTopicWeeklies = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.Student/RetrieveCompletedTopicWeeklies', request, metadata || {}, methodDescriptor_Student_RetrieveCompletedTopicWeeklies);
};

module.exports = proto.manabie.bob;